// src/components/Footer.tsx
import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          Built by{' '}
          <a href="https://olamideoladokun.com" target="_blank" rel="noopener noreferrer">
            Olamide Oladokun
          </a>
        </div>
        <div className="footer-center">
          Powered by{' '}
          <a href="https://pytorch.org" target="_blank" rel="noopener noreferrer">
            PyTorch
          </a>{' '}
          ·{' '}
          <a href="https://fastapi.tiangolo.com" target="_blank" rel="noopener noreferrer">
            FastAPI
          </a>{' '}
          ·{' '}
          <a href="https://github.com/endgameinc/malimg" target="_blank" rel="noopener noreferrer">
            Malimg Dataset
          </a>
        </div>
        <div className="footer-right">
          <a href="https://github.com/0la-mide/malware-cnn" target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;